module.exports = __webpack_public_path__ + "static/media/404-error.ad22d422.jpg";